import Modal from 'bootstrap/js/src/modal';
import {parseHTML} from "../Core/common";
import IMask from 'imask';
import {Validator} from "../Core/validator";

let config = {
    'size': '',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">${this.title}
                ${this.closeBtm}</div>`;
    },
    'closeBtm': `<button 
                        type="button" 
                        style="z-index: 1;"
                        class="btn-close" 
                        data-bs-dismiss="modal" 
                        aria-label="Close"
                    >
                </button>`,
    showEvent: function () {
    },
    hiddenEvent: function () {
    },
    hideEvent: function () {
    },
};


export const modal = (options, showEvent, hiddenEvent) => {
    if (Validator.isString(options)) {
        options = {'message': options};
    }
    if (showEvent) {
        options.showEvent = showEvent;
    }
    if (hiddenEvent) {
        options.hiddenEvent = hiddenEvent;
    }
    let modalConfig = {...config, ...options};

    modalBuilder(modalConfig, showEvent, hiddenEvent, hiddenEvent);
};


const modalBuilder = (options) => {
    document.querySelectorAll('.modal').forEach(t => {
        let modal = Modal.getInstance(t);
        if (modal) {
            modal.hide();
        }
        t.remove();
    });

    let element = parseHTML(`<div class="modal fade modal-call" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  ${options.size}">
        <div class="modal-content">
            ${options.header.call(options)}
            <div class="modal-body">
                ${options.message}
            </div>
             ${options.footer}
        </div>
    </div>
</div>`);

    document.querySelector('body').append(element);


    let to = document.querySelector('.modal');

    let modal = new Modal(to);
    modal.show();

    if (to.querySelector('[type="tel"]')) {
        IMask(
            to.querySelector('[type="tel"]'), {
                mask: '{8} (000) 000-00-00'
            });
    }

    let show = (event) => {
        if (options.showEvent) {
            options.showEvent(to, modal, event);
        }

    };

    let hide = event => {
        if (options.hideEvent) {
            options.hideEvent(to, modal, event);
        }
    };

    let hiden = event => {
        to.remove();
        to.removeEventListener('shown.bs.modal', show);
        to.removeEventListener('hidden.bs.modal', hiden);
        to.removeEventListener('hide.bs.modal', hide);
        if (options.hiddenEvent) {
            options.hiddenEvent(event);
        }
    };


    to.addEventListener('shown.bs.modal', show);
    to.addEventListener('hidden.bs.modal', hiden);
    to.addEventListener('hide.bs.modal', hide);
};